/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Injectable } from '@angular/core';
import {
  BuilderFormSchemaFactory,
  BuilderUserContext, FormRootSchema,
  FormState, FormStateSchema,
  whenCreateOrEditMode,
} from '@gh/builder-shared';
import { BuilderPermission } from '@gh/builder-shared-data';
import { IS_REGION_NZ, TextTypes } from '@gh/common-shared';
import { FormMode } from '@gh/core-ui';
import { SystemVarsAccountsTwilio } from '../../../resources/model/system-vars-accounts.model';

@Injectable()
export class SystemVarsAccountsTwilioFormState extends FormState<SystemVarsAccountsTwilio> {
  isNzRegion = IS_REGION_NZ;

  constructor(
    schemaFactory: BuilderFormSchemaFactory,
    private userContext: BuilderUserContext,
  ) {
    super(schemaFactory);
  }

  protected buildSchema(value: SystemVarsAccountsTwilio, { root }: FormStateSchema): FormRootSchema {
    const mode = this.userContext.hasPermission(BuilderPermission.Setup.SystemVariables.Accounts.EDIT) ?
      FormMode.EditMode : FormMode.ViewMode;

    return root({
      enabled: whenCreateOrEditMode(),
      mode,
      optimisticLock: true,
      children: {
        twilioPhoneNumber: { required: true, type: !this.isNzRegion ? TextTypes.Phone : undefined },
        twilioWebhook: void 0,
        twilioWebhookUrlPhoneCalls: void 0,
      },
    });
  }
}
